import { Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage.jsx'
import EventPage from './pages/EventPage.jsx'
import PlacePage from './pages/PlacePage.jsx'
import AccountPage from './pages/AccountPage.jsx'
import BotInfoPage from './pages/BotInfoPage.jsx'
import { ProtectedRoute } from './components/ProtectedRoute'
import Login from './components/Login'
import Signup from './components/Signup'
import ForgotPassword from './components/ForgotPassword'

const ENABLE_SEARCH = import.meta.env.VITE_ENABLE_SEARCH !== 'false'

export default function App() {
    return (
        <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />

            {/* Search-related routes - only available when search is enabled */}
            {ENABLE_SEARCH && (
                <>
                    <Route path="/event/:id" element={<EventPage />} />
                    <Route path="/place/:id" element={<PlacePage />} />
                </>
            )}

            <Route path="/bots" element={<BotInfoPage />} />

            {/* Auth routes - only available when search is enabled */}
            {ENABLE_SEARCH && (
                <>
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />

                    {/* Protected routes */}
                    <Route element={<ProtectedRoute />}>
                        <Route path="/account" element={<AccountPage />} />
                    </Route>
                </>
            )}
        </Routes>
    )
}
